import { Gettable, Settable } from '../../../objects/configAttributes/configAttributeInterfaces';
import { SimpleConfigObservableWithValue } from '../../../objects/configAttributes/simpleConfigObservableWithValue';
import { SimpleConfigValue } from '../../../objects/configAttributes/simpleConfigValue';

export class LayerOptions<T1> {
  public pane = new SimpleConfigValue<T1, string>(this._context);
  public opacity = new SimpleConfigObservableWithValue<T1, number>(this._context);

  constructor(protected _context: T1) { }

  public getAll(): Record<string, unknown> {
    const returnObj: Record<string, unknown> = {};
    Object.keys(this).forEach((key: string) => {
      if (typeof (this[key] as Gettable<T1, unknown>).get === 'function') {
        returnObj[key] = this.get(key);
      }
    });
    return returnObj;
  }

  public setOptions(options: Record<string, unknown>): T1 {
    for (const key in options) {
      // eslint-disable-next-line no-prototype-builtins
      if (options.hasOwnProperty(key)) {
        this.set(key, options[key]);
      }
    }
    return this._context;
  }

  public set<T2 = unknown>(key: string, value: T2): T1 {
    if (typeof this[key] === 'undefined') {
      this[key] = new SimpleConfigValue<T1, null | T2>(this._context, null, value);
    } else {
      (this[key] as Settable<T1, T2>).set(value);
    }
    return this._context;
  }

  public get<T2 = unknown>(key: string): null | T2 {
    const option = (this[key] as Gettable<T1, T2>);
    return ((option != null) && (typeof option.get === 'function'))
      ? option.get()
      : null;
  }
}
